module.exports = __webpack_public_path__ + "img/bj.7acfda15.png";